import type { RoofEdge } from "building-types/roofs/roofEdgeTypes";
import { RoofWallFramingType } from "building-types/roofs/roofWallFramingTypes";
import type { RoofEdgeOverrides, RoofMaterialTrimAndProps, RoofSlope } from "building-types/settings/roofTypes";
import { RoofSide } from "building-types/settings/roofTypes";
import type { EaveType, EaveCutType } from "building-types/settings/settingsTypesEnum";
import type { PolyLine2 } from "geom/polyLine2Types";

interface RoofEdgeNewOptions {
  readonly subRoofId: string;
  readonly edge: PolyLine2;
  readonly outerEdge: PolyLine2;
  readonly startHeight: number;
  readonly endHeight: number;
  readonly heightOffset?: number;
  readonly eaveSlope?: number;
  readonly eaveExtensionAtCoplanarWall?: number;
  readonly eaveExtensionAtNonCoplanarRake?: number;
  readonly slopes?: RoofSlope[];
  readonly truncatedSlopes?: RoofSlope[];
  readonly oppSlopes?: RoofSlope[];
  readonly eaveType?: EaveType;
  readonly eaveCutType?: EaveCutType;
  readonly startOverhang?: number;
  readonly endOverhang?: number;
  readonly sideOverhang?: number;
  readonly exteriorWallOffsetWithFinish?: number;
  readonly exteriorWallOffsetFromOverhangDatum?: number;
  readonly isLeftEdge?: boolean;
  readonly isRightEdge?: boolean;
  readonly isStartEdge?: boolean;
  readonly isEndEdge?: boolean;
  readonly isRake?: boolean;
  readonly isCustomHipEdge?: boolean;
  readonly fullyTruncated?: boolean;
  readonly side?: RoofSide;
  readonly startAlignedHostRoofId?: string;
  readonly endAlignedHostRoofId?: string;
  readonly validEdgeForCustomHip?: boolean;
  readonly roofMaterialTrimAndProps?: RoofMaterialTrimAndProps;
  readonly roofEdgeOverrides?: RoofEdgeOverrides;
  readonly isShedHalfEdge?: boolean;
  readonly framingType?: RoofWallFramingType;
}

export function roofEdgeNew({
  subRoofId,
  edge,
  outerEdge,
  startHeight,
  endHeight,
  heightOffset = 0,
  eaveSlope = Number.POSITIVE_INFINITY,
  eaveExtensionAtCoplanarWall = 0,
  eaveExtensionAtNonCoplanarRake = 0,
  slopes = [],
  truncatedSlopes = slopes,
  oppSlopes = [],
  eaveType,
  eaveCutType,
  sideOverhang = 0,
  startOverhang = 0,
  endOverhang = 0,
  exteriorWallOffsetWithFinish = 0,
  exteriorWallOffsetFromOverhangDatum = 0,
  isLeftEdge = false,
  isRightEdge = false,
  isStartEdge = false,
  isEndEdge = false,
  isRake = false,
  isCustomHipEdge = false,
  fullyTruncated = false,
  startAlignedHostRoofId,
  endAlignedHostRoofId,
  side = RoofSide.INVALID,
  validEdgeForCustomHip = false,
  roofMaterialTrimAndProps,
  roofEdgeOverrides,
  isShedHalfEdge = false,
  framingType = RoofWallFramingType.AUTO,
}: RoofEdgeNewOptions): RoofEdge {
  return {
    subRoofId,
    edge,
    outerEdge,
    eaveSlope,
    eaveExtensionAtCoplanarWall,
    eaveExtensionAtNonCoplanarRake,
    slopes,
    truncatedSlopes,
    oppSlopes,
    startHeight,
    endHeight,
    heightOffset,
    sideOverhang,
    startOverhang,
    endOverhang,
    exteriorWallOffsetWithFinish,
    exteriorWallOffsetFromOverhangDatum,
    side,
    isLeftEdge,
    isRightEdge,
    isStartEdge,
    isEndEdge,
    isRake,
    isCustomHipEdge,
    fullyTruncated,
    eaveType,
    eaveCutType,
    startAlignedHostRoofId,
    endAlignedHostRoofId,
    validEdgeForCustomHip,
    roofMaterialTrimAndProps,
    roofEdgeOverrides,
    isShedHalfEdge,
    framingType,
  };
}
